import { ILocationInfo } from '~src/personalSpace/model/ILocationInfo';
import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';

import { ExplorableItemType } from '../../spacesPlatform/models/ContentType';
import { ContentDraftStatus } from '../serverApi/types/ContentDraft';

export enum DraftReferenceType {
  PublishedWorkbook = 'PUBLISHED_WORKBOOK',
  UnpublishedWorkbook = 'UNPUBLISHED_WORKBOOK',
}

export enum ContainerType {
  PersonalSpace = 'PERSONAL_SPACE',
  Project = 'PROJECT',
  Unknown = 'UNKNOWN',
}

export interface Draft {
  containerLuid: string;
  containerType: ContainerType;
  createdAt: string;
  draftLuid: string;
  draftReferenceId: string;
  draftReferenceType: DraftReferenceType;
  name: string;
  parentContentLuid?: string;
  parentRevisionId: string;
  siteLuid: string;
  snapshotTimelineId: string;
  thumbnailURL: string;
  updatedAt: string;
  userLuid: string;
}

export interface DraftCount {
  total_count: number;
  published_workbook_draft_count: number;
  unpublished_workbook_draft_count: number;
}

export interface WorkbookDraftContent {
  containerLuid: string;
  containerType: ContainerType;
  contentType: ExplorableItemType;
  createdAt: Date;
  draftLuid: string;
  draftStatus: ContentDraftStatus;
  editUrl?: string;
  id: string;
  location?: ILocationInfo;
  name: string;
  owner: IUserInfo;
  thumbnailUrl: string;
  updatedAt: Date;
}

export const WorkbookDraftContentType: ExplorableItemType = 'workbook';

export type DraftRequestBody = Blob | string[];

export enum DraftTagsParentType {
  card = 'CARD',
  list = 'LIST',
  none = 'NONE'
}

export enum DraftTagType {
  neverPublished = 'NEVER_PUBLISHED',
  unpublished = 'DRAFT',
  staticTag = 'STATIC_TAG'  // for draft tags that should not have a tooltip
}

// Drafts state
export type DraftsById = { [key: string]: Draft } | null;

export interface DraftsState {
  readonly drafts: DraftsById;
  readonly isBusy: boolean;
}

export interface DraftWorkbookSpaceProps {
  draftUpdatedAt: string;
  draftLuid: string;
}

// Generated from printing out a 404 error
// Don't go around using this blindly
export interface SpringError {
  summary: string;
  callstack: string;
  code: string;
  detail: string;
}

export interface SpringResponse {
  error: SpringError;
}
